import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA service worker registration only runs in production builds (CRA serves
// the dev bundle without one). Phase 0 keeps it disabled to avoid stale assets;
// re-enable when offline support is required.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      // Silently ignore in case service worker is not deployed yet.
    });
  });
}
